import axiosClient from "./axiosClient"

const profileApi = {
  getUserProfile: () => axiosClient.get("/profile/", { authRequired: true }),

  updateUserProfile: data =>
    axiosClient.patch("/profile/", data, { authRequired: true }),

  updateUserProfileFull: data =>
    axiosClient.put("/profile/", data, { authRequired: true }),

  profileCommented: () =>
    axiosClient.get("/profile-commented/", { authRequired: true }),

  profileLiked: () =>
    axiosClient.get("/profile-liked/", { authRequired: true }),
}

export default profileApi
